import { ThemeProvider } from '@ori-ui/mui';
import { TestIdProvider } from '@ori/testid-generator';
import type { VFC } from 'react';
import { Suspense } from 'react';

import { Loading, ChatButton, ErrorBoundary } from './components';
import { ConfigurationProvider } from './contexts';
import type { AppConfiguration } from './types';

interface AppProps {
  configuration: AppConfiguration;
}

export const App: VFC<AppProps> = ({ configuration }) => (
  <ConfigurationProvider value={configuration}>
    <Suspense fallback={<Loading />}>
      <ErrorBoundary>
        <ThemeProvider
          enableCacheProvider
          cacheKey="online-genesys-widget"
        >
          <TestIdProvider
            team="Framework"
            project="genesys-widget"
          >
            <ChatButton {...configuration} />
          </TestIdProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </Suspense>
  </ConfigurationProvider>
);
